module.exports = __webpack_public_path__ + "static/media/heart_small.6f682234.svg";